import { createFileRoute } from '@tanstack/react-router';

import DayToDayForm from 'src/components/DayToDayForm';
import PageHeader from 'src/components/PageHeader';
import { InnerMaxWidthContainer } from 'src/layouts/InnerMaxWidthContainer';

export const Route = createFileRoute('/(app)/care/day-to-day/mobility')({
    component: AdlsEditMobilityComponent,
});

function AdlsEditMobilityComponent() {
    return (
        <InnerMaxWidthContainer>
            <PageHeader />
            <DayToDayForm
                dayToDayName="MOBILITY"
                title={(firstName) => `Does ${firstName} need help getting around?`}
                description="Share any mobility needs or stability assistance they require including preferred footwear, assistive devices, or other support."
                placeholder="e.g., uses a walker, needs help with stairs, requires assistance getting in/out of bed"
                nextRoute="/care/day-to-day/meals"
            />
        </InnerMaxWidthContainer>
    );
}
